// extracted by mini-css-extract-plugin
export var buttons = "_6p-0";
export var buttonsActive = "_6p-h";
export var cancelConfirm = "_6p-1";
export var closeButton = "_6p-2";
export var column = "_6p-3";
export var container = "_6p-4";
export var detailHeader = "_6p-6";
export var detailTitle = "_6p-7";
export var detailsContent = "_6p-5";
export var header = "_6p-8";
export var headerWithClose = "_6p-9";
export var icon = "_6p-a";
export var infoIcon = "_6p-c";
export var informationContainer = "_6p-b";
export var sideDrawer = "_6p-d";
export var sideDrawerOpen = "_6p-e";
export var stickyFooter = "_6p-f";
export var typeOption = "_6p-g";